import { DateTime } from 'luxon'

const name = 'birthdate'

const validator = (value, params) => {
  let currentDate = DateTime.local()
  let birthDate = DateTime.fromISO(value)

  let minAge = params && params.minAge ? parseInt(params.minAge) : 0
  let diff = currentDate.diff(birthDate, 'years')

  return diff.years >= minAge
}

export default {
  name,
  validator
}
